"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./myPointTask.request"), exports);
(0, tslib_1.__exportStar)(require("./submitPointTask.request"), exports);
(0, tslib_1.__exportStar)(require("./myPointDetail.request"), exports);
(0, tslib_1.__exportStar)(require("./myPointDetailNew.request"), exports);
(0, tslib_1.__exportStar)(require("./exchange.request"), exports);
(0, tslib_1.__exportStar)(require("./mall.request"), exports);
(0, tslib_1.__exportStar)(require("./followWechat.request"), exports);
(0, tslib_1.__exportStar)(require("./updateInviteTime.request"), exports);
(0, tslib_1.__exportStar)(require("./politeInvitationInit.request"), exports);
(0, tslib_1.__exportStar)(require("./lotteryInit.request"), exports);
(0, tslib_1.__exportStar)(require("./runLottery.request"), exports);
(0, tslib_1.__exportStar)(require("./rankPoint.request"), exports);
(0, tslib_1.__exportStar)(require("./productdetail.request"), exports);
(0, tslib_1.__exportStar)(require("./productexchangeinit.request"), exports);
//# sourceMappingURL=index.js.map